import { observer } from "mobx-react-lite";
import { ResponsivePie } from "@nivo/pie";
import "./CaseStatistics.scss";
import useTranslation from "../../../hooks/useTranslation";
import { transformCategoriesToChartData } from "./utils";
import configStore from "../../../stores/ConfigStore";

const CaseStatistics = observer(() => {
  const { t } = useTranslation();

  return (
    <div className="caseStatisticsContainer">
      <div className="chartContainer">
        <h3>{t("most-used-case-categories")}</h3>
        <ResponsivePie
          data={transformCategoriesToChartData(
            configStore.appConfig.caseStatistics?.mostCaseCategories || [],
            t
          )}
          margin={{ top: 75, right: 75, bottom: 75, left: 75 }}
          innerRadius={0.5}
          padAngle={4}
          cornerRadius={1}
          activeOuterRadiusOffset={8}
          borderWidth={1}
          borderColor={{ from: "color", modifiers: [["darker", 0.2]] }}
          arcLabel={(item) => `%${item.value}`}
          arcLinkLabelsSkipAngle={2}
          arcLinkLabelsTextColor="#333333"
          arcLinkLabelsThickness={2}
          arcLinkLabelsColor={{ from: "color" }}
          arcLabelsSkipAngle={2}
          arcLabelsTextColor={{ from: "color", modifiers: [["darker", 2]] }}
        />
      </div>
      <div className="row">
        <div className="column">
          <h3>{t("most-offered-cases")}</h3>
          <ul>
            {configStore.appConfig.caseStatistics?.mostOfferedCases.map(
              (caseItem, index) => (
                <li key={`most-offered-${index}`}>- "{caseItem}"</li>
              )
            )}
          </ul>
        </div>
        <div className="column">
          <h3>{t("most-hand-shake-cases")}</h3>
          <ul>
            {configStore.appConfig.caseStatistics?.mostHandShakeCases.map(
              (caseItem, index) => (
                <li key={`most-hand-shake-${index}`}>- "{caseItem}"</li>
              )
            )}
          </ul>
        </div>
      </div>
    </div>
  );
});

export default CaseStatistics;
